<div class="cf-dlg sp-dlg">
    <div class="cf-dlg-header">
        <div class="cf-dlg-icon" [class.cf-dlg-icon--green]="ticket?.resolved"><mat-icon>{{ ticket?.resolved ? 'check_circle' : 'forum' }}</mat-icon></div>
        <div class="sp-dlg-heading">
            <h2 class="cf-dlg-title">{{ ticket?.subject || 'Incidencia' }}</h2>
            <p class="cf-dlg-subtitle" *ngIf="ticket">
                <span class="sp-chip" [class.sp-chip--resolved]="ticket.resolved">{{ ticket.resolved ? 'Resuelta' : 'Abierta' }}</span>
                <span class="sp-chip sp-chip--muted">{{ ticket.category }}</span>
                <span class="sp-chip sp-chip--muted">
                    <span class="sp-dot" [ngClass]="'sp-dot--' + priority.className"></span>Prioridad {{ priority.label | lowercase }}
                </span>
            </p>
        </div>
        <button mat-icon-button class="cf-dlg-close" (click)="closeDialog()" aria-label="Cerrar">
            <mat-icon>close</mat-icon>
        </button>
    </div>

    <app-loading-state *ngIf="loading" message="Cargando conversación…"></app-loading-state>

    <div class="cf-dlg-body" *ngIf="!loading && loadError">
        <div class="ex-error-box">
            <mat-icon>error_outline</mat-icon>
            <span>No se ha podido cargar la incidencia.</span>
        </div>
    </div>

    <ng-container *ngIf="!loading && !loadError && ticket">
        <div class="cf-dlg-body sp-thread" #thread>
            <div class="sp-legend">
                <span><span class="sp-legend__dot sp-legend__dot--client"></span>Cliente</span>
                <span><span class="sp-legend__dot sp-legend__dot--support"></span>Soporte Handly</span>
            </div>

            <ng-container *ngTemplateOutlet="messageTpl; context: { $implicit: { name: ticket.name, message: ticket.message, date: ticket.date } }"></ng-container>
            <ng-container *ngFor="let m of messages; trackBy: trackByIndex">
                <ng-container *ngTemplateOutlet="messageTpl; context: { $implicit: m }"></ng-container>
            </ng-container>

            <ng-template #messageTpl let-m>
                <div class="sp-msg" [class.sp-msg--support]="isSupport(m.name)">
                    <div class="sp-msg__avatar">
                        <mat-icon *ngIf="isSupport(m.name); else clientInitial">support_agent</mat-icon>
                        <ng-template #clientInitial>{{ initials(m.name) }}</ng-template>
                    </div>
                    <div class="sp-msg__bubble">
                        <div class="sp-msg__role">{{ isSupport(m.name) ? 'Soporte Handly' : 'Cliente' }}</div>
                        <div class="sp-msg__head">
                            <strong>{{ m.name }}<ng-container *ngIf="isMine(m.name)"> (tú)</ng-container></strong>
                            <span>{{ m.date | date:'dd/MM/yyyy · HH:mm' }}</span>
                        </div>
                        <p class="sp-msg__text">{{ m.message }}</p>
                    </div>
                </div>
            </ng-template>

            <div class="sp-resolved-note" *ngIf="ticket.resolved">
                <mat-icon>check_circle</mat-icon> Esta incidencia está resuelta
            </div>
        </div>

        <div class="sp-reply" *ngIf="!ticket.resolved">
            <textarea [(ngModel)]="reply" rows="3" placeholder="Escribe tu respuesta…  (Ctrl + Enter para enviar)"
                [disabled]="sending" (keydown)="onReplyKeydown($event)" aria-label="Respuesta"></textarea>
        </div>

        <div class="cf-dlg-footer">
            <button *ngIf="!ticket.resolved" mat-stroked-button class="cf-dlg-btn-secondary sp-resolve-btn"
                [disabled]="resolving || sending" (click)="resolveTicket()">
                <mat-icon>done_all</mat-icon> Marcar como resuelta
            </button>
            <span class="sp-footer-spacer"></span>
            <button mat-stroked-button class="cf-dlg-btn-secondary" (click)="closeDialog()">Cerrar</button>
            <button *ngIf="!ticket.resolved" mat-flat-button class="cf-dlg-btn-primary"
                [disabled]="!reply.trim() || sending" (click)="send()">
                <mat-icon>send</mat-icon> {{ sending ? 'Enviando…' : 'Enviar' }}
            </button>
        </div>
    </ng-container>
</div>
